import React, { useState, useContext } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import useAuth from '../hooks/useAuth';
import { AuthContext } from '../context/AuthContext';
import LoadingScreen from '../components/LoadingScreen';
import { getFirstAllowedPath, isPathAllowed } from '../config/accessControl';

const drawerWidth = 270;

const AdminLayout = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { allowedPaths } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) return <LoadingScreen />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (!isPathAllowed(location.pathname, allowedPaths)) {
    const fallbackPath = getFirstAllowedPath(allowedPaths);
    return (
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 4 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>Access Denied</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            This page is not assigned to your staff role.
          </Typography>
          <Button variant="contained" onClick={() => navigate(fallbackPath)}>Go to available page</Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: { md: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Topbar onToggleSidebar={() => setSidebarOpen((prev) => !prev)} />
        <Box
          component="main"
          sx={{
            flex: 1,
            p: { xs: 2, md: 3 },
            backgroundColor: 'background.default',
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminLayout;
